// src/components/LandingPage.js
import React from 'react';
import './Reso.css';
import RESO1 from './images/RESO1.svg';
import RESO2 from './images/RESO2.svg';


const Landing = () => {
    const headerText = "Unleash The Power Of Our Finest Stories!!";
    const colors = [
        "#A8D5BA", "#F8B400", "#FFC1C1", "#A1C6EA", "#E3E3E3", "#C5E1A5",
        "#FFCCBC", "#CFD8DC", "#FDD835", "#80CBC4", "#FFAB91", "#B39DDB",
        "#BCAAA4", "#81D4FA", "#FFF59D", "#B0BEC5", "#FFEB3B", "#8C9EFF",
        "#FFCDD2", "#B2DFDB", "#D1C4E9", "#C8E6C9", "#FFCC80", "#E1BEE7",
        "#C5CAE9", "#FFE0B2", "#E0F7FA", "#FFE082", "#D7CCC8", "#DCEDC8"
    ];

    return (
        <div className="landing-page">
            <header className="heeader">
                <h1>
                    {headerText.split('').map((char, index) => (
                        <span key={index} style={{ color: colors[index % colors.length] }}>
                            {char}
                        </span>
                    ))}
                </h1>
            </header>
            <div className="content">
                <div className="card">
                    <img src={RESO1} alt="DevOps" className="card-image" />
                    <div className="tags">
                        <span className="tag">Creative</span>
                        <span className="tag">Idea</span>
                        <span className="tag">Design</span>
                        <span className="tag">Technology</span>
                        <span className="tag">DevOps</span>
                    </div>
                    <p className="card-text">
                        New technology is not good or evil in and of itself.
                    </p>
                    <p className="card-description">
                        DevOps is a blend of culture, practices, and tools that streamline software development and IT operations. It aims to deliver applications and services faster and more reliably. Imagine development and operations working together seamlessly to build, test, and deploy software at high speed.
                    </p>
                </div>
                <div className="cardd">
                    <img src={RESO2} alt="DevOps" className="card-image" />
                    <div className="tags">
                        <span className="tag">Creative</span>
                        <span className="tag">Idea</span>
                        <span className="tag">Design</span>
                        <span className="tag">Technology</span>
                        <span className="tag">DevOps</span>
                    </div>
                    <p className="card-text">
                        New technology is not good or evil in and of itself.
                    </p>
                    <p className="card-description">
                        DevOps is a blend of culture, practices, and tools that streamline software development and IT operations. It aims to deliver applications and services faster and more reliably. Imagine development and operations working together seamlessly to build, test, and deploy software at high speed.
                    </p>
                </div>
            </div>
            <button className="load-more">Load more</button>
        </div>
    );
};

export default Landing;
